import type { RootState } from '../store/structureDefinitions/cartState';

import { userProfileSelectors } from './userProfileSelectors';

const isShoppingForAnother = (state: RootState) => state.user.municipalUser.isShoppingForAnother;

const isShoppingForMunicipal = (state: RootState) =>
    state.user.municipalUser.isShoppingForMunicipal;

const isOrdererMunicipal = (state: RootState) => state.user.municipalUser.isOrdererMunicipal;

const isMunicipalShopperOrOrderer = (state: RootState) =>
    state.user.municipalUser.isShoppingForMunicipal || state.user.municipalUser.isOrdererMunicipal;

const punchoutUserInfo = (state: RootState) => state.user.punchout;
const isPunchoutUser = (state: RootState) =>
    state.user.punchout.isPunchout || state.ui.debug.mockUserIsPunchout;
const isUserAllowedToDefineStoreContext = (state: RootState) =>
    !userProfileSelectors.isShoppingForAnother(state) && !isPunchoutUser(state);

export const userInfoSelectors = {
    isShoppingForAnother,
    isShoppingForMunicipal,
    isMunicipalShopperOrOrderer,
    isOrdererMunicipal,
    punchoutUserInfo,
    isPunchoutUser,
    isUserAllowedToDefineStoreContext,
};
